<template>
    <div class="ui-content dashboard add-ch-arrow user-section">
        <v-card class="mx-auto normal-card autohg">
            <div class="add-user-form">
                <v-row>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="b-data">
                        <v-text-field v-model="name" label="Name" hide-details dense outlined class="required"></v-text-field>
                        <InputError :data="error.name" />    
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="b-data">
                        <v-text-field v-model="email" label="Email ID" hide-details dense outlined class="required"></v-text-field>
                        <InputError :data="error.email"/>
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                    <v-col cols="12" sm="4" class="rg-0 b-data">
                        <v-btn @click="onSubmit" :loading="loading" class="right-btn cust-btn" color="primary">Done</v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" class="blk"></v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'AddUserDeo',
     props: ["tab"],
    data() {
        return {
            loading: false,
            email: null,
            name: null,
            error: {
                email: {
                    type: null,
                    message: null,
                },
                name: {
                    type: null,
                    message: null,
                },
            }

        }
    },
    methods: {
        ...mapActions({
            signUp: "userStore/signUp"
        }),
        onSubmit() {
            this.loading = true;
            if (this.validate()) {

                this.signUp({ internal: true, name: this.name.trim(), email: this.email.trim(), role_id: this.roleIds.ED }).then(response => {
                        this.loading = false;
                        this.email = '',
                            this.name = ''
                        this.$toasted.success(`${response.message}`, { icon: 'check_circle', className:'new-class' });


                    })
                    .catch(err => {
                        this.loading = false;
                    });


            } else {
                this.loading = false;
            }
        },
        validate() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            if ((!this.name) || this.name.trim().length < 1) {
                this.error.name.type = 'error';
                this.error.name.message = 'Please enter name';
                isValid = false;
            }
            if (this.name  && this.name.trim().length >70) {
                this.error.name.type = 'error';
                this.error.name.message = 'Name should not contain more than 70 characters';
                isValid = false;
            }
            if (!this.email||this.email.length<1) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter email ID.';
                isValid = false;
            }
            else if (!this.isValidEmail(this.email)) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter a valid email ID.';
                isValid = false;
            }
            return isValid;
        }
    },
    watch: {
        email(val){
            if(this.email){
            this.error.email.type = null;
            }
        },
        name(val){
            this.error.name.type = null;
        },
        tab(){
            this.email = '';
            this.name = '';
            
            this.error={
                email: {
                    type: null,
                    message: null,
                },
                name: {
                    type: null,
                    message: null,
                },
            };
        }
    },

}
</script>